module.exports = __webpack_public_path__ + "static/media/0027_LES_STRUCTURES_GONDOLES.28d31560.png";